import { ICONS } from "../constants";

// Iconos del set de marca (Ángel Linares): rejilla de 24, trazo de 1.7, sin
// relleno. Sustituyen a los equivalentes de Bootstrap (rejilla de 16, relleno).
// `giro` rota 180º un icono del set para obtener su opuesto.
const MARCA = {
  "x-lg":              { d: "m6 6 12 12M18 6 6 18" },
  "x":                 { d: "m6 6 12 12M18 6 6 18" },
  "plus-lg":           { d: "M12 4v16M4 12h16" },
  "dash-lg":           { d: "M4 12h16" },
  "dash":              { d: "M4 12h16" },
  "check2":            { d: "m4 12 5 5L20 6" },
  "chevron-left":      { d: "m15 6-6 6 6 6" },
  "chevron-right":     { d: "m9 6 6 6-6 6" },
  "chevron-down":      { d: "m6 9 6 6 6-6" },
  "chevron-up":        { d: "m6 9 6 6 6-6", giro: true },
  "arrow-right-short": { d: "M4 12h16m-6-6 6 6-6 6" },
  "arrow-left":        { d: "M4 12h16m-6-6 6 6-6 6", giro: true },
  "search":            { d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-2 6 6 6" },
  "download":          { d: "M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5" },
  "calendar3":         { d: "M4 5h16v16H4ZM8 3v4M16 3v4M4 10h16" },
  "person":            { d: "M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0M4 21v-2a8 8 0 0 1 16 0v2" },
  "globe":             { d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M3 12h18M12 3c-5 5-5 13 0 18 5-5 5-13 0-18" },
  "box-arrow-up-right":{ d: "M14 3h7v7M10 14 21 3M10 3H3v18h18v-7" },
  "sun":               { d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M5 5l1.8 1.8M17.2 17.2 19 19M5 19l1.8-1.8M17.2 6.8 19 5" },
  "lock-fill":         { d: "M5 11h14v9H5ZM8 11V8a4 4 0 0 1 8 0v3" },
  "list-check":        { d: "M5 3.5h14a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1ZM8 9.5l2 2 3.5-3.5M8 16h8" },
  // Sin equivalente hoy en la app, listos para usar.
  "menu":              { d: "M4 6h16M4 12h16M4 18h16" },
  "mail":              { d: "M4 5h16v14H4ZM4 6l8 7 8-7" },
};

export default function Icon({ name, size=14, color="currentColor", style={} }) {
  const propio = MARCA[name];
  if (propio) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
        fill="none" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"
        aria-hidden="true" focusable="false" style={{flexShrink:0,display:"inline-block",...style}}>
        <path d={propio.d} transform={propio.giro ? "rotate(180 12 12)" : undefined}/>
      </svg>
    );
  }
  const path = ICONS[name];
  if (!path) return null;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16"
      fill={color} aria-hidden="true" focusable="false" style={{flexShrink:0,display:"inline-block",...style}}>
      {path.split(" M ").map((seg,i)=>(
        <path key={i} d={i===0?seg:"M "+seg}/>
      ))}
    </svg>
  );
}
